<div style="margin-bottom: 30px;" [hidden]="!loader()">
  <div style="margin-bottom: 115px;">
    <div style="padding: 10px 20px 20px 20px">
      <div style="padding: 10px 0px 0px 0px;">
        <div>
          <label class="uk-form-label" style="font-size: 1.3rem !important; font-style: oblique;"
            [ngStyle]="{'color': style.Button}">รายละเอียดประกันภัย</label>
        </div>
      </div>
    </div>
    <div *ngIf="insuredetail_data().product_family_flag == 2">
      <div style="padding: 0 20px 10px 20px;">
        <hr style="margin-bottom: 8px;">
        <label class="uk-form-label" style="font-size: 0.8rem !important; color: #555;">หมายเลขอ้างอิง :
          {{insuredetail_data().refNo || ''}}</label>
        <div uk-grid>
          <div class="uk-width-auto">
            <label class="uk-form-label"
              style="font-size: 1.0rem !important; font-style: oblique; color: #333;">ผู้เอาประกันภัยจำนวน</label>
          </div>
          <div class="uk-width-expand" style="text-align: right;">
            <label class="uk-form-label"
              style="font-size: 1.0rem !important; font-style: oblique; color: #333;">{{insuredetail_data().main_protection
              ? insuredetail_data().main_protection.length : '-'}} ท่าน</label>
          </div>
        </div>
      </div>
      <div style="padding: 10px 20px; width: auto;" [ngStyle]="{'background-color': style.BG}">
        <div uk-grid>
          <div class="uk-width-auto">
            <label class="uk-form-label"
              style="font-size: 1.0rem !important; font-style: oblique; color: #333;">ยอดชำระเต็มจำนวน</label>
          </div>
          <div class="uk-width-expand" style="text-align: right;">
            <label class="uk-form-label"
              style="font-size: 1.2rem !important; font-style: oblique; color: #333;">{{numberWithCommas(insuredetail_data().total_premium_main)||'-'}}
              บาท</label>
          </div>
        </div>
      </div>
    </div>
    <div *ngFor="let item of insuredetail_data().main_protection; let i = index;">
      <div style="padding: 10px 20px 10px 20px; width: auto;" [ngStyle]="{'background-color': style.Button}">
        <div style="margin-top: 0px !important" uk-grid>
          <div class="uk-width-auto">
            <label class="uk-form-label" style="font-size: 0.7rem !important; color: white;">ผู้เอาประกันภัย</label>
          </div>
          <div class="uk-width-expand">
            <label *ngIf="insuredetail_data().product_family_flag == 1" class="uk-form-label"
              style="font-size: 0.7rem !important; word-wrap: break-word; float: right; color: white;">หมายเลขอ้างอิง :
              {{insuredetail_data().refNo || ''}}</label>
          </div>
        </div>
        <div>
          <label class="uk-form-label"
            style="font-size: 1.3rem !important; font-style: oblique; color: white;">{{item[0].name ||''}}</label>
        </div>
        <br>
        <div style="margin-top: 0px !important" uk-grid>
          <div class="uk-width-auto">
            <label class="uk-form-label"
              style="font-size: 1.0rem !important; font-style: oblique; color: white;">ค่าเบี้ยประกันภัยรวม</label>
          </div>
          <div class="uk-width-expand">
            <label class="uk-form-label"
              style="font-size: 1.0rem !important; word-wrap: break-word; font-style: oblique; float: right; color: white;">{{getTotalPremium(item)}}
              บาท</label>
          </div>
        </div>
      </div>
      <div style="padding-top: 20px;">
        <div class="uk-width-auto uk-flex uk-flex-center">
          <label *ngIf="insuredetail_data().product_family_flag == 1" class="uk-form-label"
            style="font-size: 0.8rem !important;" [ngStyle]="{'color': style.Button}">ผลิตภัณฑ์ต่ออายุ</label>
          <label *ngIf="insuredetail_data().product_family_flag == 2" class="uk-form-label"
            style="font-size: 0.8rem !important;" [ngStyle]="{'color': style.Button}">ผลิตภัณฑ์ต่ออายุ
            ผู้เอาประกันลำดับที่ {{i+1}}</label>
        </div>
        <div id="{{ 'object-' + i }}"
          class="uk-slider-container-offset sortables" uk-slider="center: true">
          <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1">
            <ul class="uk-slider-items uk-grid">
              <li *ngFor="let insure of item">
                <div [ngStyle]="{'margin-bottom': item.length < 2 && '20px' }" class="uk-card uk-card-default uk-border-rounded slide-card">
                  <div style="padding:8px;">
                    <div uk-grid>
                      <div class="uk-width-1-3" style="align-self: center;">
                        <div class="circular--logo">
                          <img src="images/{{insure.logo}}">
                        </div>
                      </div>
                      <div class="uk-width-2-3" style="padding-left: 5px;">
                        <label class="uk-form-label"
                          style="font-size: 0.7rem !important; color: #70757a;">{{insure.group_name}}</label>
                        <br />
                        <label class="uk-form-label"
                          style="font-size: 0.9rem !important; color: #333;">{{insure.product_name}}</label>
                        <br />
                        <label class="uk-form-label"
                          style="font-size: 0.9rem !important; color: #333;">{{insure.plan || '-'}}</label>
                        <!-- <label class="uk-form-label" style="font-size: 0.6rem !important; word-wrap: break-word; color: #84B0D5;">{{numberWithCommas(insuredetail_data().protection1)}}</label> -->
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous
              uk-slider-item="previous"></a>
            <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next
              uk-slider-item="next"></a>
          </div>
          <ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin +dot-nav-blue"></ul>
        </div>
      </div>
      <div style="padding: 0 20px; width: auto;">
        <div>
          <div style="margin-top: 0px !important" uk-grid>
            <div class="uk-width-auto">
              <label class="uk-form-label" style="font-size: 1.0rem !important; font-weight: bold;"
                [ngStyle]="{'color': style.Button}">ค่าเบี้ยประกันภัย</label>
            </div>
            <div class="uk-width-expand">
              <label class="uk-form-label"
                style="font-size: 1.0rem !important; word-wrap: break-word; font-weight: bold; float: right;"
                [ngStyle]="{'color': style.Button}">{{numberWithCommas(item[insurance_index[i]||0].premium)}}
                บาท</label>
            </div>
          </div>
          <div style="margin-top: 0px !important" uk-grid>
            <div class="uk-width-auto">
              <label class="uk-form-label"
                style="font-size: 1.0rem !important; font-weight: bold; color: red;">ครบกำหนด</label>
            </div>
            <div class="uk-width-expand">
              <label class="uk-form-label"
                style="font-size: 1.0rem !important; word-wrap: break-word; font-weight: bold; float: right; color: red;">{{getExpireDate(item[insurance_index[i]||0].due_date)}}</label>
            </div>
          </div>
        </div>
        <div *ngIf="insuredetail_data().product_family_flag == 2"
          style="padding: 10px 0; width: auto; text-align: center;">
          <ul uk-accordion>
            <li>
              <a class="uk-accordion-title" href="#" style="font-size: 0.9rem !important; text-decoration: underline;"
                [ngStyle]="{'color': style.Button}">ดูรายละเอียดความคุ้มครอง</a>
              <div class="uk-accordion-content">
                <div style="padding: 10px 20px; margin: 10px 0; width: auto;"
                  [ngStyle]="{'background-color': style.BG}">
                  <div class="uk-width-auto uk-flex uk-flex-center">
                    <label class="uk-form-label" style="font-size: 0.9rem !important;">รายละเอียดความคุ้มครอง</label>
                  </div>
                </div>
                <div *ngIf="!(item[insurance_index[i]] && item[insurance_index[i]].protection_detail)"
                  style="margin: 10px 0;" class="uk-flex uk-flex-center">-</div>
                <div *ngIf="item[insurance_index[i]] && item[insurance_index[i]].protection_detail">
                  <div style="text-align: left;">
                    <label class="uk-form-label "
                      style="font-size: 0.9rem !important;">{{item[insurance_index[i]||0].protection_category}}</label>
                  </div>
                  <table class="uk-table uk-table-striped" style="margin-bottom: 0;">
                    <tbody>
                      <tr class="uk-table-expand" *ngFor="let protect of item[insurance_index[i]].protection_detail">
                        <td class="uk-width-2-3 uk-padding-remove-right" style="text-align: left; font-size: 0.8rem !important;">{{protect.protection_name}}</td>
                        <td class="uk-width-1-3" style="text-align: right; font-size: 0.8rem !important;">{{protect.protection_value}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div *ngIf="insuredetail_data().product_family_flag == 1">
          <div style="padding: 10px 20px; margin: 10px 0; width: auto;" [ngStyle]="{'background-color': style.BG}">
            <div class="uk-width-auto uk-flex uk-flex-center">
              <label class="uk-form-label" style="font-size: 0.9rem !important;">รายละเอียดความคุ้มครอง</label>
            </div>
          </div>
          <div *ngIf="!(item[insurance_index[i]] && item[insurance_index[i]].protection_detail)"
            style="margin: 10px 0;" class="uk-flex uk-flex-center">-</div>
          <div *ngIf="item[insurance_index[i]] && item[insurance_index[i]].protection_detail">
            <div style="text-align: left;">
              <label class="uk-form-label "
                style="font-size: 0.9rem !important;">{{item[insurance_index[i]||0].protection_category}}</label>
            </div>
            <table class="uk-table uk-table-striped" style="margin-bottom: 0;">
              <tbody>
                <tr class="uk-table-expand" *ngFor="let protect of item[insurance_index[i]].protection_detail">
                  <td class="uk-width-2-3 uk-padding-remove-right" style="text-align: left; font-size: 0.8rem !important;">{{protect.protection_name}}</td>
                  <td class="uk-width-1-3" style="text-align: right; font-size: 0.8rem !important;">{{protect.protection_value}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <hr style="margin: 10px 20px;">
    <div style="padding: 5px 0 50px 0;" class="uk-flex uk-flex-center uk-padding-remove-horizontal">
      <button type="submit"
        class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
        style="min-width: 300px !important;" [ngStyle]="{'background-color': style.Button}"
        (click)="onSubmit()">ต่ออายุประกัน
      </button>
    </div>
  </div>
</div>

<app-loader *ngIf="!loader()"></app-loader>